// Generated by ReScript, PLEASE EDIT WITH CARE


function stringToFieldType(str) {
  switch (str) {
    case "BankNamesSelect" :
        return "BankNamesSelect";
    case "CardExpiryMonth" :
        return "CardExpiryMonth";
    case "CardExpiryYear" :
        return "CardExpiryYear";
    case "CardHolderName" :
        return "CardHolderName";
    case "CardNetwork" :
        return "CardNetwork";
    case "CardNumber" :
        return "CardNumber";
    case "Country" :
        return "Country";
    case "CryptoCurrency" :
        return "CryptoCurrency";
    case "CryptoNetwork" :
        return "CryptoNetwork";
    case "Cvc" :
        return "Cvc";
    case "Date" :
        return "Date";
    case "DateOfBirth" :
        return "DateOfBirth";
    case "Dropdown" :
        return "Dropdown";
    case "Email" :
        return "Email";
    case "FirstName" :
        return "FirstName";
    case "LanguagePreference" :
        return "LanguagePreference";
    case "LastName" :
        return "LastName";
    case "Phone" :
        return "Phone";
    case "PhoneCountryCode" :
        return "PhoneCountryCode";
    case "State" :
        return "State";
    default:
      return "Generic";
  }
}

export {
  stringToFieldType ,
}
/* No side effect */
